<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [columns]="columns"
  [filters]="filters"
  [url]="url"
  (onActionButtonClick)="actionButtonClick($event.actionType, $event.row)"
  [columnWidths]="columnWidths"
  (handleGetUserList)="getUserList(1, pageSize, filters)"
  [type]="'userList'"
></app-tables>



<!-- [pageSize]="pageSize"
[tableLoading]="userListLoading"
(onPageChange)="onPageChange($event)"
(onPageSizeChange)="onPageSizeChange($event)"
[data]="userList"
[totalCount]="totalUserCount"
(filtersChange)="filterUserList($event.filters, $event.sort)"
  [totalPage]="totalPage"
 -->


